function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.0859 5.38281C11.2031 5.47656 11.2031 5.66406 11.0859 5.78125L6.1875 10.6797C6.07031 10.7969 5.90625 10.7969 5.78906 10.6797L0.890625 5.78125C0.773438 5.66406 0.773438 5.47656 0.890625 5.38281L1.33594 4.91406C1.45312 4.79688 1.64062 4.79688 1.73438 4.91406L5.39062 8.54688V0.53125C5.39062 0.390625 5.50781 0.25 5.67188 0.25H6.32812C6.46875 0.25 6.60938 0.390625 6.60938 0.53125V8.54688L10.2422 4.91406C10.3359 4.79688 10.5234 4.79688 10.6406 4.91406L11.0859 5.38281Z",
  fill: "#D13338"
});

var SvgIndexDownIconLight = function SvgIndexDownIconLight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIndexDownIconLight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/IndexDownIconLight.4129f2ef.svg";
export { ForwardRef as ReactComponent };